import { render } from "./btn.vue?vue&type=template&id=1fab5c56&scoped=true&ts=true"
import script from "./btn.vue?vue&type=script&lang=ts"
export * from "./btn.vue?vue&type=script&lang=ts"

import "./btn.vue?vue&type=style&index=0&id=1fab5c56&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fab5c56"]])

export default __exports__